import * as React from "react";
import * as _ from "underscore";
import { connect } from "react-redux";

import { AppShape, HurdleShape, DocTypes } from "@eave/shared/types/api";
import HurdleView from "underwriter_dashboard/shared/HurdleView";
import DocEntry from "../shared/DocEntry";
import { DocumentUploader } from "../../DocumentUploader";
import { HurdleStatus } from "../HurdleStatus";
import { loadApp } from "../actions";

const mapUnderwriterStateToProps = (state, ownProps) => ({
  documents: ownProps.documents,
  documentType: ownProps.documentType,
  prompt: ownProps.prompt,
  onUpload: ownProps.onUpload,
  ownerEntityType: ownProps.ownerEntityType,
  ownerEntityID: ownProps.ownerEntityID,
  applicationID: ownProps.applicationID,
});

const mapUnderwriterDispatchToProps = dispatch => ({
  updateApplication: (dispatchType, payload) => {
    loadApp(dispatch, payload.id);
  },
});

const UnderwriterDocumentUploader = connect(
  mapUnderwriterStateToProps,
  mapUnderwriterDispatchToProps,
)(DocumentUploader as any);

interface HurdleEditorProps {
  dispatch?: Function;
  app: AppShape;
  hurdle: HurdleShape;
  onHide: Function;
}

const docFromProps = props => {
  return (
    _.chain(props.app.documents)
      .filter((d: any) => d.type === DocTypes.TitleCommitment)
      // most recently uploaded title commitment is displayed.
      .sortBy((d: any) => -1 * parseInt(d.id, 10))
      .first()
      .value()
  );
};

class TitleCommitmentHurdleEditor extends React.Component<HurdleEditorProps, any> {
  constructor(props) {
    super(props);
    this.state = { doc: docFromProps(props) };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ doc: docFromProps(nextProps) });
  }

  render() {
    const { app, hurdle, onHide } = this.props;
    const { doc } = this.state;
    const { settlement_agent } = app.contacts;

    if (!settlement_agent) {
      return (
        <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
          <div className="owner-occupancy__modal-body">
            <HurdleStatus status="yellow" /> Waiting for settlement agent.
          </div>
        </HurdleView>
      );
    }
    if (!doc) {
      const address = `${settlement_agent.address_line1} ${settlement_agent.address_line2}
      ${settlement_agent.city}, ${settlement_agent.state} ${settlement_agent.postal_code}`;

      return (
        <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
          <div className="owner-occupancy__modal-body">
            <div>
              <HurdleStatus status="yellow" />
              Please order a title commitment or upload it below.
              <h4>Settlement agent</h4>
              <dl className="dl-horizontal">
                <dt>Name</dt>
                <dd>{settlement_agent.name}</dd>
                <dt>Address</dt>
                <dd>{address}</dd>
                <dt>Phone</dt>
                <dd>{settlement_agent.phone}</dd>
                <dt>Email</dt>
                <dd>{settlement_agent.email}</dd>
              </dl>
              <UnderwriterDocumentUploader
                applicationID={app.id}
                documents={app.documents}
                documentType={DocTypes.TitleCommitment}
                prompt="Please upload Title Commitment"
              />
            </div>
          </div>
        </HurdleView>
      );
    }
    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        <DocEntry
          {...this.props}
          docType={DocTypes.TitleCommitment}
          docNotFoundMsg="Title Commitment not available."
        />
      </HurdleView>
    );
  }
}

export default connect()(TitleCommitmentHurdleEditor);
